import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PathwaySection } from '../components/PathwaySection';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ToolsSection } from '../components/ToolsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
interface HomePageProps {
  isDark: boolean;
}
export function HomePage({
  isDark
}: HomePageProps) {
  return <main data-id="element-1613">
      <HeroSection isDark={isDark} data-id="element-1614" />
      <PathwaySection data-id="element-1615" />
      <ServicesSection data-id="element-1616" />
      <HowItWorksSection data-id="element-1617" />
      <ToolsSection data-id="element-1618" />
      <AboutSection data-id="element-1619" />
      <ContactSection data-id="element-1620" />
    </main>;
}